import { useSelector } from "react-redux";
import { isNullUndefined } from "../services/utils";
import { ApplicationState } from "../store";

const visibleControlsCache = new Set<string>();

function useKogControlElementId(elementId: string) {
	const { controlsByScreen } = useSelector((state: ApplicationState) => state.control);

	if (visibleControlsCache.has(elementId)) {
		return true;
	}

	if (isNullUndefined(controlsByScreen.data)) {
		return false;
	}

	const findedControlById = controlsByScreen.data.some((i) => i.elementId === elementId);

	if (findedControlById) {
		visibleControlsCache.add(elementId);
	}

	return findedControlById;
}

export default useKogControlElementId;
